import React, { useState, useContext, useRef, useEffect } from "react";
import { GlobalContext } from "../../context/provider";
import { MdDone, MdOutlineClose, MdKeyboardArrowDown, MdSearch, MdDeleteForever } from "react-icons/md";
import numberbeautify from "../../utils/numberbeautify";
import createaction from "../../context/action/sell/createaction";
import getinvoiceaction from "../../context/action/sell/getinvoiceaction";
import '../../component/css/onprintcss.css';
import { Sellitemprint } from "./sellitemprint";
import { useReactToPrint } from "react-to-print";
import getitemrecommendaction from "../../context/action/item/getitemrecommendaction";
import money_rounding from "../../utils/money_rounding";
import iqd_rounding from "../../utils/iqd_rounding";

const Sell = () => {
  var today = new Date();
    today = today.getFullYear() + '-' + (today.getMonth() + 1) + '-' + today.getDate() + ' ' + today.getHours() + ':' + today.getMinutes() + ':' + today.getSeconds();
  const { initState, recaller, setrecaller, initDispatch, clear } = useContext(GlobalContext);
  const [items, setitems] = useState([]);
  const [item_suggestion, setitem_suggestion] = useState([]);
  const [text, settext] = useState();
  const [sell_invoice_type, setsell_invoice_type] = useState('cash');
  const [sell_invoice_discount, setsell_invoice_discount] = useState(0);
  const [sell_invoice_dollar_price, setsell_invoice_dollar_price] = useState(initState?.dollar_price || 0);
  const [invoiceno, setinvoiceno] = useState(0);
  const [isOpen, setIsOpen] = useState(false);
  const [customer, setcustomer] = useState(initState?.customer);
  const [customer_id, setcustomer_id] = useState();
  const [customer_name, setcustomer_name] = useState("");
  const [customer_address, setcustomer_address] = useState("");
  const [customer_phone, setcustomer_phone] = useState("");
  const [customer_loan, setcustomer_loan] = useState(0);
  const [sell_invoice_loan_in_amount, setsell_invoice_loan_in_amount] = useState(0);
  const [searchTerm, setSearchTerm] = useState("");
  const [sell_invoice_date, setsell_invoice_date] = useState("");

  const dropdownRef = useRef(null);
  const textRef = useRef(null);
  const printRef = useRef();

  const [sell_loading, setsell_loading] = useState(false);
  const [error, seterror] = useState(false);
  const [error1, seterror1] = useState(false);
  const [error2, seterror2] = useState(false);
  const [error3, seterror3] = useState(false);
  const [error4, seterror4] = useState(false);

  const printFn = useReactToPrint({
      contentRef: printRef,
      documentTitle: "AwesomeFileName",
      preserveAfterPrint: true,
      print: (printIframe) =>
      new Promise(() => {
        printIframe.style.display = "none";

        printIframe.contentWindow?.print();
      }),
  });

  useEffect(() => {
      const handleClickOutside = (event) => {
          if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
              setIsOpen(false);
              // setitem_suggestion([]);
          }
          if (textRef.current && !textRef.current.contains(event.target)) {
              // setIsOpen(false);
              setitem_suggestion([]);
          }
      };
      document.addEventListener('mousedown', handleClickOutside);
      return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const handlePresetClick = (option) => {
      setcustomer_id(option?.customer_id);
      setcustomer_name(option?.customer_name);
      setcustomer_address(option?.customer_address);
      setcustomer_phone(option?.customer_phone);
      setcustomer_loan(option?.customer_loan);
      setsell_invoice_type('cash');
      setIsOpen(false);
  };

  const filtereddoctor = customer.filter(option =>
      option.customer_name.toLowerCase().includes(searchTerm.toLowerCase())
  );
  return (
    <div>
      {/* Print section */}
      <div
        style={{
          position: 'absolute',
          left: '-99999px',
          top: 0
        }}
      >
          <Sellitemprint ref={printRef} invoiceno={invoiceno} sell_invoice_type={sell_invoice_type} loan_back_amount={sell_invoice_loan_in_amount} remained_loan={money_rounding(Number(customer_loan)+(
                            sell_invoice_type=="loan"?
                              Number(items.reduce(
                                (a, v) =>
                                  (a =
                                    Number(a) +
                                    (v.item_sell_state=="pay"?money_rounding(Number(v.item_sell_price) * (Number(v.item_qty))):0)),
                                0
                              ))*Number(1-sell_invoice_discount/100)-sell_invoice_loan_in_amount
                            :0))} sell_invoice_discount={sell_invoice_discount} sell_invoice_dollar_price={sell_invoice_dollar_price} customer_name={customer_name} customer_address={customer_address} customer_phone={customer_phone} sell_invoice_date={today} items={items} />
      </div>

      {/* Main content */}
      <div className="min-h-screen bg-slate-50 p-6 md:p-8">
        {/* Page Header */}
        <div className="flex items-center justify-between mb-8">
          <div>
            <h1 className="text-2xl font-bold text-slate-800">فرۆشتن</h1>
            <p className="text-sm text-slate-400 mt-0.5">-</p>
          </div>
        </div>

        {/* Top form section */}
        <div className="bg-white border border-slate-100 rounded-xl p-6 mb-6 shadow-sm">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 items-end">
            {/* Customer dropdown */}
            <div className="relative" ref={dropdownRef}>
              <label
                  className={
                    error
                    ? "block text-sm font-medium text-red-500 mb-1 text-right"
                    : "block text-sm font-medium text-slate-500 mb-1 text-right"
                  }
              >
                  کڕیار
              </label>
              <div 
                  className={
                    error
                    ? "w-full h-10 px-3 border flex justify-between items-center border-red-500 rounded-lg text-sm text-slate-800 placeholder:text-slate-400 focus:outline-none focus:ring-2 focus:ring-red-500 focus:border-transparent bg-white"
                    : "w-full h-10 px-3 border flex justify-between items-center border-slate-200 rounded-lg text-sm text-slate-800 placeholder:text-slate-400 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent bg-white"
                  }
                  onClick={() => {setIsOpen(!isOpen);seterror(false);}}
                  title={customer_id && customer_id!=0 ?numberbeautify(customer.filter((res)=>res.customer_id==customer_id)[0].customer_loan)+"$":''}
              >
                  <div className="flex-1 truncate">
                      {customer_id && customer_id!=0 ? 
                          <span className="text-gray-700">{customer.filter((res)=>res.customer_id==customer_id)[0].customer_name}</span> : 
                          <span className="text-gray-500">ناوی کڕیار</span>
                      }
                  </div>
                  <MdKeyboardArrowDown className={`text-gray-500 transition-transform duration-200 ${isOpen ? 'rotate-180' : ''}`} />
              </div>
              {isOpen && (
                  <div className="absolute w-full mt-2 bg-white border border-gray-200 rounded-lg shadow-lg max-h-60 overflow-hidden z-10">
                      <div className="p-2 border-b border-gray-200">
                          <div className="relative">
                              <MdSearch className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" />
                              <input
                                  type="text"
                                  className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                                  placeholder="بگەڕێ"
                                  value={searchTerm}
                                  onChange={(e) => setSearchTerm(e.target.value)}
                                  onClick={(e) => e.stopPropagation()}
                              />
                          </div>
                      </div>
                      <div className="overflow-auto max-h-48">
                          {filtereddoctor.length > 0 ? (
                              filtereddoctor.map((option) => (
                                  <div
                                      key={option.customer_id}
                                      className="flex items-center p-3 hover:bg-gray-50 cursor-pointer border-b border-gray-100 last:border-b-0 transition-colors duration-150"
                                      onClick={() => handlePresetClick(option)}
                                  >
                                      <span className="text-gray-700 hover:text-gray-900">{option.customer_name}</span>
                                  </div>
                              ))
                          ) : (
                              <div className="p-3 text-center text-gray-500">
                                  هیچ کڕیارێک نەدۆزایەوە!
                              </div>
                          )}
                      </div>
                  </div>
                )}
            </div>

          {/* Invoice type */}
          <div className="w-full">
            <label
              for="invoice_type"
              className={"block text-sm font-medium text-slate-500 mb-1 text-right"}
            >
              جۆری وەسڵ
            </label>
            <select
              id="invoice_type"
              disabled={customer_id==1?true:false}
              className={
                customer_id==1
                ? "w-full h-10 px-3 border border-slate-200 rounded-lg text-sm text-slate-800 placeholder:text-slate-400 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent bg-gray-200 cursor-not-allowed"
                : "w-full h-10 px-3 border border-slate-200 rounded-lg text-sm text-slate-800 placeholder:text-slate-400 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent bg-white"
              }
              value={sell_invoice_type}
              onChange={(val) => {setsell_invoice_type(val.target.value);setsell_invoice_loan_in_amount(0);}}
            >
              <option value="cash">کاش</option>
              <option value="loan">قەرز</option>
            </select>
          </div>

          {/* Discount */}
          <div className="w-full">
            <label
              className={
                error1
                  ? "block text-sm font-medium text-red-500 mb-1 text-right"
                  : "block text-sm font-medium text-slate-500 mb-1 text-right"
              }
              for="sell_invoice_discount"
            >
              داشکاندن
            </label>
            <input
              className={
                error1
                  ? "w-full h-10 px-3 border border-red-500 rounded-lg text-sm text-slate-800 placeholder:text-slate-400 focus:outline-none focus:ring-2 focus:ring-red-500 focus:border-transparent bg-white"
                  : "w-full h-10 px-3 border border-slate-200 rounded-lg text-sm text-slate-800 placeholder:text-slate-400 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent bg-white"
              }
              id="sell_invoice_discount"
              type="number"
              placeholder=""
              onClick={(val)=>{val.target.select()}}
              value={sell_invoice_discount}
              onChange={(val) => setsell_invoice_discount(val.target.value)}
              onFocus={() => seterror1(false)}
            />
          </div>

          {/* Dollar price */}
          <div className="w-full">
            <label
              className={
                error2
                  ? "block text-sm font-medium text-red-500 mb-1 text-right"
                  : "block text-sm font-medium text-slate-500 mb-1 text-right"
              }
              for="sell_invoice_dollar_price"
            >
              نرخی دۆلار
            </label>
            <input
              className={
                error2
                  ? "w-full h-10 px-3 border border-red-500 rounded-lg text-sm text-slate-800 placeholder:text-slate-400 focus:outline-none focus:ring-2 focus:ring-red-500 focus:border-transparent bg-white"
                  : "w-full h-10 px-3 border border-slate-200 rounded-lg text-sm text-slate-800 placeholder:text-slate-400 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent bg-white"
              }
              id="sell_invoice_dollar_price"
              type="number"
              placeholder=""
              onClick={(val)=>{val.target.select()}}
              value={sell_invoice_dollar_price}
              onChange={(val) => setsell_invoice_dollar_price(val.target.value)}
              onFocus={() => seterror2(false)}
            />
          </div>
          {/* <div className="w-full">
            <label
              className={
                error4
                  ? "block text-sm font-medium text-red-500 mb-1 text-right"
                  : "block text-sm font-medium text-slate-500 mb-1 text-right"
              }
              for="sell_invoice_date"
            >
              بەروار
            </label>
            <input
              className={
                error4
                  ? "w-full h-10 px-3 border border-red-500 rounded-lg text-sm text-slate-800 placeholder:text-slate-400 focus:outline-none focus:ring-2 focus:ring-red-500 focus:border-transparent bg-white"
                  : "w-full h-10 px-3 border border-slate-200 rounded-lg text-sm text-slate-800 placeholder:text-slate-400 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent bg-white"
              }
              id="sell_invoice_date"
              type="date"
              placeholder=""
              onClick={(val)=>{val.target.select()}}
              value={sell_invoice_date}
              onChange={(val) => setsell_invoice_date(val.target.value)}
              onFocus={() => seterror4(false)}
            />
          </div> */}
        </div>
        
        {/* Customer details section */}
        {customer_id==1 && (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 mt-4 items-end">
            {/* Name */}
            <div className="w-full">
              <label
                className={
                  "block text-sm font-medium text-slate-500 mb-1 text-right"
                }
                for="customer_name"
              >
                ناوی کڕیار
              </label>
              <input
                className={
                  "w-full h-10 px-3 border border-slate-200 rounded-lg text-sm text-slate-800 placeholder:text-slate-400 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent bg-white"
                }
                id="customer_name"
                type="text"
                placeholder=""
                onClick={(val)=>{val.target.select()}}
                value={customer_name}
                onChange={(val) => setcustomer_name(val.target.value)}
              />
            </div>

            {/* Address */}
            <div className="w-full">
              <label
                className={
                  "block text-sm font-medium text-slate-500 mb-1 text-right"
                }
                for="customer_address"
              >
                ناونیشان
              </label>
              <input
                className={
                  "w-full h-10 px-3 border border-slate-200 rounded-lg text-sm text-slate-800 placeholder:text-slate-400 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent bg-white"
                }
                id="customer_address"
                type="text"
                placeholder=""
                onClick={(val)=>{val.target.select()}}
                value={customer_address}
                onChange={(val) => setcustomer_address(val.target.value)}
              />
            </div>

            {/* Phone */}
            <div className="w-full">
              <label
                className={
                  "block text-sm font-medium text-slate-500 mb-1 text-right"
                }
                for="customer_phone"
              >
                ژمارەی تەلەفۆن
              </label>
              <input
                className={
                  "w-full h-10 px-3 border border-slate-200 rounded-lg text-sm text-slate-800 placeholder:text-slate-400 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent bg-white"
                }
                id="customer_phone"
                type="text"
                placeholder=""
                onClick={(val)=>{val.target.select()}}
                value={customer_phone}
                onChange={(val) => setcustomer_phone(val.target.value)}
              />
            </div>
          </div>
        )}
        </div>

        {/* Search and action section */}
        <div className="bg-gray-400 border border-gray-500 rounded-xl p-6 mb-6 shadow-sm">
          <div className="grid grid-cols-1 lg:grid-cols-4 gap-4 items-end">
            <div className="col-span-4 lg:col-span-3 relative">
              <label
                className={
                  "block text-base font-medium text-white mb-1 text-right"
                }
                for="get_item"
              >
                ناوی کاڵا / کۆد
              </label>
              <input
                className={
                  "w-full h-12 px-3 border border-slate-200 rounded-lg text-sm text-slate-800 placeholder:text-slate-400 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent bg-white"
                }
                id="get_item"
                type="text"
                placeholder=""
                onClick={(val)=>{val.target.select()}}
                value={text}
                onChange={(val) => {
                  settext(val.target.value)
                  getitemrecommendaction(val.target.value)(recaller)(setrecaller)(item_suggestion)(setitem_suggestion)(settext)(clear);
                }}
                autoFocus
              />
              {item_suggestion.length>0&&text.length>0&&(
                <div ref={textRef} className="absolute left-0 right-0 mt-2 max-h-48 overflow-y-auto bg-white shadow-lg rounded-md z-10">
                  {item_suggestion.map((item, index) => (
                    <div
                      key={index}
                      className={item.item_qty>0?"px-4 py-2 hover:bg-gray-100 cursor-pointer":"px-4 py-2 bg-red-300 hover:bg-red-400 cursor-pointer"}
                      onClick={() => {
                        settext("");
                        setitem_suggestion([]);
                        if (item.item_qty <= 0) {
                          alert("یەکەی پێویست لەم خاڵایە لە مەخزەن نییە");
                          return false;
                        }
                        if (items.find((lis) => lis.item_id == item.item_id)) {
                          alert("ئەم کاڵایە پێشتر زیاد کراوە");  
                        } else {
                            setitems([{ item_id: item.item_id, item_name: item.item_name, item_barcode: item.item_barcode, item_price: item.item_price, item_qty: (1*item?.item_unit_one_of_many), item_quantity: item.item_qty, item_sell_price: item.item_price, item_sell_price_iqd: money_rounding(Number(item.item_price)*Number(sell_invoice_dollar_price)), item_sell_state: "pay", item_unit_one_qty: 0, item_unit_many_qty: 1, item_unit_one: item.item_unit_one, item_unit_many:item.item_unit_many, item_unit_one_of_many:item.item_unit_one_of_many, item_sell_buy_price: item.cost_pet_unit_one },...items]);
                        }
                      }}
                    >
                      <div className="flex items-center">
                        <span className="text-gray-700">({item?.item_name}) - </span>
                        <span className="text-gray-700">&nbsp;({item?.item_barcode}) - </span>
                        <span className="text-gray-700">&nbsp;({item?.item_unit_one} {money_rounding(Math.floor(item?.item_qty/item?.item_unit_one_of_many))}/{money_rounding(Number(item?.item_qty) % item?.item_unit_one_of_many)} {item?.item_unit_many}) - </span>
                        <span className="text-gray-700">&nbsp;({numberbeautify(item?.item_price)}$ {"یەک "+item?.item_unit_one}) - </span>
                        <span className="text-gray-700">&nbsp;({numberbeautify(money_rounding(item?.cost_pet_unit_one))}$ {"یەک "+item?.item_unit_one})</span>
                        {/* <span className="text-gray-700">{item?.item_name} - {item?.item_barcode} - ({item?.item_unit_one} {Math.floor(item.item_qty)}/{Math.round((Number(item.item_qty)-Number(Math.floor(item.item_qty)))*item.item_unit_one_of_many)} {item?.item_unit_many}) - ({numberbeautify(item?.item_price)}$ {"یەک "+item?.item_unit_one}) - ({numberbeautify(money_rounding(item?.cost_pet_unit_one))}$ {"یەک "+item?.item_unit_one})</span> */}
                      </div>
                    </div>
                  ))}
                </div>
              )}
              </div>

          {/* Action button */}
          <div className="col-span-4 lg:col-span-1">
              <button
              className={
                ((items.length < 1)||(sell_loading))
                ? "h-12 px-6 bg-indigo-300 text-white text-sm font-semibold rounded-lg transition-colors duration-150 w-full cursor-not-allowed"
                : "h-12 px-6 bg-indigo-600 hover:bg-indigo-700 text-white text-sm font-semibold rounded-lg transition-colors duration-150 w-full"
              }
              disabled={((items.length < 1)||(sell_loading)) ? true : false}
              onClick={() => {
                if(!customer_id || customer_id==0){
                  seterror(true);
                  return false;
                }
                if(sell_invoice_discount<0 || sell_invoice_discount>100){
                  seterror1(true);
                  return false;
                }
                if(sell_invoice_dollar_price<=0){
                  seterror2(true);
                  return false;
                }
                if(sell_invoice_type=="loan" && sell_invoice_loan_in_amount<0){
                  seterror3(true);
                  return false;
                }
                // if(sell_invoice_date==""||!sell_invoice_date){
                //   seterror4(true);
                //   return false;
                // }

                if (items.filter((lis) => lis.item_qty > 0).length < 1) {
                  setitems(items.filter((lis) => lis.item_qty > 0));
                  alert("کاڵای پێویست لە وەسڵدا نییە");
                } else if(items.some((lis) => Number(lis.item_qty)>Number(lis.item_quantity))) {
                  alert("کێشە لە بڕی کاڵا هەیە");
                } else {
                    if (
                      window.confirm(
                        "دڵنیایی فرۆشتن"
                      ) == true
                    ) {
                      if(sell_invoice_type=="cash"){
                        setsell_invoice_loan_in_amount(0);
                      }
                      setitems(items.filter((lis) => lis.item_qty > 0));
                      setsell_loading(true);
                      createaction(sell_invoice_type, sell_invoice_date, "", sell_invoice_discount, sell_invoice_dollar_price, sell_invoice_loan_in_amount, customer_name, customer_address, customer_phone, customer_id, initState.token.user_id, items)(recaller)(
                        setrecaller
                      )(initDispatch)(clear)(printFn)(setinvoiceno)(setsell_loading);
                    }
                }
            }}
          >
            {sell_loading?<div className="flex items-center justify-center space-x-2">
                            <svg
                              className="animate-spin h-5 w-5 text-white"
                              xmlns="http://www.w3.org/2000/svg"
                              fill="none"
                              viewBox="0 0 24 24"
                            >
                              <circle
                              className="opacity-25"
                              cx="12"
                              cy="12"
                              r="10"
                              stroke="currentColor"
                              strokeWidth="4"
                              ></circle>
                              <path
                              className="opacity-75"
                              fill="currentColor"
                              d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"
                              ></path>
                            </svg>
                        </div>:"فرۆشتن"}
          </button>
          </div>
        </div>
        </div>

        {/* Items table */}
        {items.length > 0 && (
          <div className="bg-white border border-slate-100 rounded-xl shadow-sm overflow-x-auto">
            <table className="w-full">
              <thead>
                <tr className="bg-slate-50 border-slate-100 border-b">
                    <th className="px-6 py-3 text-right text-xs font-semibold text-slate-500 uppercase tracking-wide">
                      ناوی کاڵا - کۆد
                    </th>
                    <th className="px-6 py-3 text-right text-xs font-semibold text-slate-500 uppercase tracking-wide">
                      دۆخی فرۆشتن
                    </th>
                    <th className="px-6 py-3 text-right text-xs font-semibold text-slate-500 uppercase tracking-wide">
                      نرخ
                    </th>
                    <th className="px-6 py-3 text-right text-xs font-semibold text-slate-500 uppercase tracking-wide">
                       نرخ (دینار)
                    </th>
                    <th className="px-6 py-3 text-right text-xs font-semibold text-slate-500 uppercase tracking-wide">
                      بڕ
                    </th>
                    <th className="px-6 py-3 text-right text-xs font-semibold text-slate-500 uppercase tracking-wide">
                      بڕ - تاک
                    </th>
                    <th className="px-6 py-3 text-right text-xs font-semibold text-slate-500 uppercase tracking-wide">
                      کۆی نرخ
                    </th>
                    <th className="px-6 py-3 text-right text-xs font-semibold text-slate-500 uppercase tracking-wide">
                      ڕەشکردنەوە
                    </th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-slate-50">
                  {items.map((lis, index) => (
                    <tr key={index} className={lis.item_qty>lis.item_quantity?"bg-red-400":"bg-white"}>
                      <td className="px-6 py-4 text-sm font-medium text-slate-800 text-right" title={
                        lis.item_unit_one+Math.floor(lis.item_quantity/lis.item_unit_one_of_many)+"/"+(Number(lis.item_quantity) % lis.item_unit_one_of_many)+lis.item_unit_many
                      }>
                        <div className="flex">
                          <p>
                            {lis.item_name}
                          </p>
                          <p>
                            -
                          </p>
                          <p>
                            {lis.item_barcode}
                          </p>
                        </div>
                      </td>
                      <td className="px-6 py-4 text-sm font-medium text-slate-800 text-right">
                        <select
                          id="item_sell_state"
                          className={
                            "w-[120px] lg:w-full h-10 px-3 border border-slate-200 rounded-lg text-sm text-slate-800 placeholder:text-slate-400 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent bg-white"
                          }
                          value={lis.item_sell_state}
                          onChange={(val) => {
                            setitems(
                              items.map((lis, indexx) =>
                                index == indexx
                                  ? {
                                      item_id: lis.item_id,
                                      item_name: lis.item_name,
                                      item_barcode: lis.item_barcode,
                                      item_price: lis.item_price,
                                      item_sell_price: lis.item_sell_price,
                                      item_sell_price_iqd: lis.item_sell_price_iqd,
                                      item_qty: lis.item_qty,
                                      item_quantity: lis.item_quantity,
                                      item_unit_one:lis.item_unit_one,
                                      item_unit_many:lis.item_unit_many,
                                      item_unit_one_of_many:lis.item_unit_one_of_many,
                                      item_unit_one_qty: lis.item_unit_one_qty,
                                      item_unit_many_qty: lis.item_unit_many_qty,
                                      item_sell_state:val.target.value,
                                      item_sell_buy_price: lis.item_sell_buy_price,
                                    }
                                  : lis
                              )
                            );
                          }}
                        >
                          <option value="pay">فرۆش</option>
                          <option value="gift">دیاری</option>
                        </select>
                      </td>
                      <td className="px-6 py-4 text-sm font-medium text-slate-800 text-right">
                        <input
                          title={numberbeautify(money_rounding(lis?.item_sell_buy_price))+" $"}
                          className={
                            lis.item_sell_state == 'gift'
                          ? "w-[120px] lg:w-full h-10 px-3 border border-gray-200 rounded-lg text-sm text-slate-800 placeholder:text-slate-400 focus:outline-none focus:ring-2 bg-gray-200 cursor-not-allowed"
                          : "w-[120px] lg:w-full h-10 px-3 border border-slate-200 rounded-lg text-sm text-slate-800 placeholder:text-slate-400 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent bg-white"
                          }
                          id="grid-last-name"
                          type="number"
                          placeholder=""
                          disabled={lis.item_sell_state == 'gift' ? true : false}
                          onClick={(val)=>{val.target.select()}}
                          value={lis.item_sell_price}
                          onChange={(val) => {
                            setitems(
                              items.map((lis, indexx) =>
                                index == indexx
                                  ? {
                                      item_id: lis.item_id,
                                      item_name: lis.item_name,
                                      item_barcode: lis.item_barcode,
                                      item_price: lis.item_price,
                                      item_sell_price: val.target.value,
                                      item_sell_price_iqd: money_rounding(Number(val.target.value)*Number(sell_invoice_dollar_price)),
                                      item_qty: lis.item_qty,
                                      item_quantity: lis.item_quantity,
                                      item_unit_one:lis.item_unit_one,
                                      item_unit_many:lis.item_unit_many,
                                      item_unit_one_of_many:lis.item_unit_one_of_many,
                                      item_unit_one_qty: lis.item_unit_one_qty,
                                      item_unit_many_qty: lis.item_unit_many_qty,
                                      item_sell_state:lis.item_sell_state,
                                      item_sell_buy_price: lis.item_sell_buy_price,
                                    }
                                  : lis
                              )
                            );
                          }}
                        />
                      </td>
                      <td className="px-6 py-4 text-sm font-medium text-slate-800 text-right">
                        <input
                          title={numberbeautify(money_rounding(Number(lis?.item_sell_buy_price)*Number(sell_invoice_dollar_price)))+" IQD"}
                          className={
                            lis.item_sell_state == 'gift'
                          ? "w-[120px] lg:w-full h-10 px-3 border border-gray-200 rounded-lg text-sm text-slate-800 placeholder:text-slate-400 focus:outline-none focus:ring-2 bg-gray-200 cursor-not-allowed"
                          : "w-[120px] lg:w-full h-10 px-3 border border-slate-200 rounded-lg text-sm text-slate-800 placeholder:text-slate-400 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent bg-white"
                          }
                          id="grid-last-name"
                          type="number"
                          placeholder=""
                          disabled={lis.item_sell_state == 'gift' ? true : false}
                          onClick={(val)=>{val.target.select()}}
                          value={lis.item_sell_price_iqd}
                          onChange={(val) => {
                            setitems(
                              items.map((lis, indexx) =>
                                index == indexx
                                  ? {
                                      item_id: lis.item_id,
                                      item_name: lis.item_name,
                                      item_barcode: lis.item_barcode,
                                      item_price: lis.item_price,
                                      item_sell_price: money_rounding(Number(val.target.value)/Number(sell_invoice_dollar_price)),
                                      item_sell_price_iqd: val.target.value,
                                      item_qty: lis.item_qty,
                                      item_quantity: lis.item_quantity,
                                      item_unit_one:lis.item_unit_one,
                                      item_unit_many:lis.item_unit_many,
                                      item_unit_one_of_many:lis.item_unit_one_of_many,
                                      item_unit_one_qty: lis.item_unit_one_qty,
                                      item_unit_many_qty: lis.item_unit_many_qty,
                                      item_sell_state:lis.item_sell_state,
                                      item_sell_buy_price: lis.item_sell_buy_price,
                                    }
                                  : lis
                              )
                            );
                          }}
                        />

                        {/* {numberbeautify(lis.item_sell_price_iqd)} */}
                        {/* {numberbeautify(money_rounding(Number(lis.item_sell_price)*Number(sell_invoice_dollar_price)))} */}
                      </td>
                      <td className="px-6 py-4 text-sm font-medium text-slate-800 text-right">
                        <input
                          title={numberbeautify(money_rounding(lis?.item_unit_one_of_many))}
                          className={
                            "w-[120px] lg:w-full h-10 px-3 border border-slate-200 rounded-lg text-sm text-slate-800 placeholder:text-slate-400 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent bg-white"
                          }
                          id="grid-last-name"
                          type="number"
                          placeholder=""
                          onClick={(val)=>{val.target.select()}}
                          value={lis.item_unit_many_qty}
                          onChange={(val) => {
                            const newManyQty = Number(val.target.value);
                            const oneQty = Number(lis.item_unit_one_qty);
                            const oneOfMany = Number(lis.item_unit_one_of_many);
                            
                            // Calculate total quantity:
                            // 1. Contribution from many units (newManyQty * oneOfMany)
                            // 2. Add contribution from individual units (oneQty)
                            const totalQty = (newManyQty * oneOfMany) + oneQty;

                            setitems(
                              items.map((item, indexx) =>
                                index === indexx
                                  ? {
                                      ...item,
                                      item_qty: totalQty,
                                      item_unit_many_qty: newManyQty,
                                      // Preserve other values
                                      item_unit_one_qty: oneQty
                                    }
                                  : item
                              )
                            );
                          }}
                      />
                      </td>
                      <td className="px-6 py-4 text-sm font-medium text-slate-800 text-right">
                        <input
                          className={
                            "w-[120px] lg:w-full h-10 px-3 border border-slate-200 rounded-lg text-sm text-slate-800 placeholder:text-slate-400 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent bg-white"
                          }
                          id="grid-last-name"
                          type="number"
                          onClick={(val)=>{val.target.select()}}
                          value={lis.item_unit_one_qty}
                          onChange={(val) => {
                            const newOneQty = Number(val.target.value);
                            const manyQty = Number(lis.item_unit_many_qty);
                            const oldOneQtyContribution = Number(lis.item_unit_one_qty);
                            const manyQtyContribution = manyQty * Number(lis.item_unit_one_of_many);
                            const totalQty = manyQtyContribution + newOneQty;

                            setitems(
                              items.map((item, indexx) =>
                                index === indexx
                                  ? {
                                      ...item,
                                      item_qty: totalQty,
                                      item_unit_one_qty: newOneQty,
                                      item_unit_many_qty: manyQty
                                    }
                                  : item
                              )
                            );
                          }}
                        />
                      </td>
                      <td className="px-6 py-4 text-sm font-medium text-slate-800 text-right">
                        {numberbeautify(money_rounding(
                          Number(lis.item_sell_price) * (Number(lis.item_qty))
                        ))} $
                      </td>
                      <td className="px-5 py-5 border-b border-gray-200  text-sm">
                        <p className="text-gray-900 whitespace-no-wrap">
                          <MdDeleteForever
                            size={28}
                            color="#e74c3c"
                            className="cursor-pointer"
                            onClick={() => {
                              setitems(
                                items.filter(
                                  (list) => list.item_id != lis.item_id
                                )
                              );
                            }}
                          />
                        </p>
                      </td>
                    </tr>
                  ))}
                  <tr>
                    <th
                      className="px-5 py-3 border-b-2 bg-slate-50 border-slate-100 text-right text-base font-semibold text-slate-500 uppercase tracking-wider"
                      colSpan={5}
                    >
                      کۆی نرخ
                    </th>
                    <td 
                      className="px-5 py-5 border-b border-slate-100 bg-white text-sm text-center"
                      colSpan={3}
                    >
                      {numberbeautify(
                        items.reduce(
                          (a, v) =>
                            (a =
                              Number(a) +
                              (v.item_sell_state=="pay"?money_rounding(Number(v.item_sell_price) * (Number(v.item_qty))):0)),
                          0
                        )
                      )} $
                    </td>
                  </tr>
                  {sell_invoice_discount>0&&(
                    <tr>
                    <th
                      className="px-5 py-3 border-b-2 bg-slate-50 border-slate-100 text-right text-base font-semibold text-slate-500 uppercase tracking-wider"
                      colSpan={5}
                    >
                      داشکاندن
                    </th>
                    <td 
                      className="px-5 py-5 border-b border-slate-100 bg-white text-sm text-center"
                      colSpan={3}
                    >
                      {numberbeautify(money_rounding(
                        Number(items.reduce(
                          (a, v) =>
                            (a =
                              Number(a) +
                              (v.item_sell_state=="pay"?money_rounding(Number(v.item_sell_price) * (Number(v.item_qty))):0)),
                          0
                        ))*Number(sell_invoice_discount/100)
                       )
                      )} $
                    </td>
                  </tr>)}
                  <tr>
                    <th
                      className="px-5 py-3 border-b-2 bg-slate-50 border-slate-100 text-right text-base font-semibold text-slate-500 uppercase tracking-wider"
                      colSpan={5}
                    >
                      کۆی گشتی
                    </th>
                    <td 
                      className="px-5 py-5 border-b border-slate-100 bg-white text-sm text-center"
                      colSpan={3}
                    >
                      {numberbeautify(money_rounding(
                        Number(items.reduce(
                          (a, v) =>
                            (a =
                              Number(a) +
                              (v.item_sell_state=="pay"?money_rounding(Number(v.item_sell_price) * (Number(v.item_qty))):0)),
                          0
                        ))*Number(1-sell_invoice_discount/100)
                       )
                      )} $
                    </td>
                  </tr>
                  <tr>
                    <th
                      className="px-5 py-3 border-b-2 bg-slate-50 border-slate-100 text-right text-base font-semibold text-slate-500 uppercase tracking-wider"
                      colSpan={5}
                    >
                      کۆی گشتی - دینار
                    </th>
                    <td 
                      className="px-5 py-5 border-b border-slate-100 bg-white text-sm text-center"
                      colSpan={3}
                    >
                      {numberbeautify(iqd_rounding((money_rounding(
                        Number(items.reduce(
                          (a, v) =>
                            (a =
                              Number(a) +
                              (v.item_sell_state=="pay"?money_rounding(Number(v.item_sell_price) * (Number(v.item_qty))):0)),
                          0
                        ))*Number(1-sell_invoice_discount/100)
                       ))*Number(sell_invoice_dollar_price))
                      )} IQD
                    </td>
                  </tr>
                  {sell_invoice_type=="loan"&&(
                    <tr>
                      <th
                        className="px-5 py-3 border-b-2 bg-slate-50 border-slate-100 text-right text-base font-semibold text-slate-500 uppercase tracking-wider"
                        colSpan={5}
                      >
                        بڕی واسڵکراو
                      </th>
                      <td 
                        className="px-5 py-2 border-b border-slate-100 bg-white text-sm text-center"
                        colSpan={3}
                      >
                        <input
                            className={
                              error3
                                ? "w-[120px] lg:w-full h-10 px-3 border border-red-500 rounded-lg text-sm text-slate-800 placeholder:text-slate-400 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent bg-white"
                                : "w-[120px] lg:w-full h-10 px-3 border border-slate-200 rounded-lg text-sm text-slate-800 placeholder:text-slate-400 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent bg-white"
                            }
                            id="grid-last-name"
                            type="number"
                            onClick={(val)=>{val.target.select()}}
                            value={sell_invoice_loan_in_amount}
                            onChange={(val) => {
                              setsell_invoice_loan_in_amount(val.target.value);
                            }}
                          />
                      </td>
                    </tr>
                    )}
                    {sell_invoice_type=="loan"&&(
                      <tr>
                        <th
                          className="px-5 py-3 border-b-2 bg-slate-50 border-slate-100 text-right text-base font-semibold text-slate-500 uppercase tracking-wider"
                          colSpan={5}
                        >
                          کۆی ماوە
                        </th>
                        <td 
                          className="px-5 py-5 border-b border-slate-100 bg-white text-sm text-center"
                          colSpan={3}
                        >
                          {numberbeautify(money_rounding(
                            Number(items.reduce(
                              (a, v) =>
                                (a =
                                  Number(a) +
                                  (v.item_sell_state=="pay"?money_rounding(Number(v.item_sell_price) * (Number(v.item_qty))):0)),
                              0
                            ))*Number(1-sell_invoice_discount/100)-sell_invoice_loan_in_amount
                          )
                          )} $
                        </td>
                      </tr>
                    )}
                    {sell_invoice_type=="loan"&&(
                      <tr>
                        <th
                          className="px-5 py-3 border-b-2 bg-slate-50 border-slate-100 text-right text-base font-semibold text-slate-500 uppercase tracking-wider"
                          colSpan={5}
                        >
                          کۆی ماوە - دینار
                        </th>
                        <td 
                          className="px-5 py-5 border-b border-slate-100 bg-white text-sm text-center"
                          colSpan={3}
                        >
                          {numberbeautify(iqd_rounding((money_rounding(
                            Number(items.reduce(
                              (a, v) =>
                                (a =
                                  Number(a) +
                                  (v.item_sell_state=="pay"?money_rounding(Number(v.item_sell_price) * (Number(v.item_qty))):0)),
                              0
                            ))*Number(1-sell_invoice_discount/100)-sell_invoice_loan_in_amount
                          ))*Number(sell_invoice_dollar_price))
                          )} IQD
                        </td>
                      </tr>
                    )}
                </tbody>
              </table>
            </div>
        )}
      </div>
    </div>
  );
};

export default Sell;
